import { z } from 'zod';
import { idSchema, isoDateSchema } from './common.js';
/**
 * Contratos de consulta de reportes y tablero. Los comparten el API (valida
 * el query string) y la web (arma los filtros), por eso viven en el dominio.
 */
/** Formatos de salida de un reporte: JSON para pantalla, CSV para Excel. */
export const REPORT_FORMATS = ['json', 'csv'];
/** Filtros comunes: agencia opcional, período opcional y formato. */
export const reportQuerySchema = z
    .object({
    branchId: idSchema.optional(),
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
    format: z.enum(REPORT_FORMATS).default('json'),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, {
    message: 'La fecha inicial no puede ser posterior a la final',
    path: ['from'],
});
/** Agrupaciones de la proyección de flujo de caja. */
export const CASH_FLOW_GRANULARITIES = ['week', 'month'];
/** Etiquetas en español de cada agrupación. */
export const CASH_FLOW_GRANULARITY_LABELS = {
    week: 'Semanal',
    month: 'Mensual',
};
/** Máximo de períodos que se pueden proyectar (dos años en meses; un año en semanas es 52). */
export const MAX_CASH_FLOW_PERIODS = 104;
/** Períodos proyectados por omisión. */
export const DEFAULT_CASH_FLOW_PERIODS = 12;
/** Proyección de flujo: cuántos períodos hacia adelante y cómo agruparlos. */
export const cashFlowQuerySchema = z.object({
    branchId: idSchema.optional(),
    format: z.enum(REPORT_FORMATS).default('json'),
    granularity: z.enum(CASH_FLOW_GRANULARITIES).default('month'),
    periods: z.coerce.number().int().min(1).max(MAX_CASH_FLOW_PERIODS).default(DEFAULT_CASH_FLOW_PERIODS),
});
/** Filtro del tablero: los usuarios con acceso a todas las agencias pueden elegir una. */
export const dashboardQuerySchema = z.object({
    branchId: idSchema.optional(),
});
//# sourceMappingURL=reports.js.map